module.exports = __webpack_public_path__ + "223fb9dce151b9be6b4e8a776a7a84a6.png";